import React, { useState, useEffect,useContext } from 'react';
import './Dashboard.css';
import Header from '../../components/header/headercontainer';
import TaskBoard from '../../components/task/smarkTaskBoard';
import AddTask from '../../components/task/addTask';
import UserStory from '../../components/userStory/userStory';
import AddUserStory from '../../components/userStory/addUserStory';
import AddFeature from '../../components/feature/addFeature';
import FeatureList from '../../components/feature/FeatureList';
import apis from '../../services/apis';
import { useSmarkDispatch, useSmarkState, useKeycloakState } from '../../Context/KeycloakContext';
import { trackPromise } from 'react-promise-tracker';
import { getTaskList } from '../../helper/context/actions';
import apiCommonParams from '../../constants/apiCommonParams';
import $ from 'jquery'
import AppContext from "../../Context/AppContext";



const Dashboard = (props) => {
    const contextDetails = useSmarkState();
    
    const dispatch = useSmarkDispatch();
    const { applicationId, siteId } = useContext(AppContext);
    const [showAddTask, _showHideAddTask] = useState(false);
    const [isTaskDeleted, setIsTaskDeleted] = useState(false);
    const [task, setTask] = useState({});
    const [showAddUserStory, _showHideAddUserStory] = useState(false);
    const [showAddFeature, _showHideAddFeature] = useState(false);
    const [commentsVisible, _showComments] = useState(false);
    const [userListState, setUserListState] = useState([]);
    const [stateFromHeader, setStateFromHeader] = useState(null);
    const [userStoryDetailState, setUserStoryDetailState] = useState(0);
    const [featureDetailState, setFeatureDetailState] = useState(null);
    const [showFeatureList, setShowFeatureList] = useState(false);

    const keycloackValue = useKeycloakState();
    const [loginuser, setUser] = useState()
    const storedToken = localStorage.getItem('keycloakToken');
    const showComments = function () {
        _showComments(!commentsVisible);   
        setHeightOfAllColumn(true);
    }
 
    const setHeightOfAllColumn = (reset) => {
        if(reset) 
            setTimeout(function(){ 
                $('.storyListView').each(function (i, e) {
                    try {
                        for (let item of Array.from(e.getElementsByClassName('taskDropArea'))) {
                            item.style.minHeight = "200px";
                        } 
                    }
                    catch {

                    }
                });
            },100);
        setTimeout(function(){ 
            $('.storyListView').each(function (i, e) {
                try { 
                    var maxHeight = Math.max(...Array.from(e.getElementsByClassName('taskDropArea')).map(x => x.clientHeight));
                    for (let item of Array.from(e.getElementsByClassName('taskDropArea'))) {
                        item.style.minHeight = maxHeight + "px";
                    }
                }
                catch {

                }
            });
        },300);
    }


    useEffect(() => {
        
        if (localStorage.getItem("currentUser")) {
            var user = JSON.parse(localStorage.getItem("currentUser"));
            setUser(user);
            
            if (user) {
                apiCommonParams.userid = user.userId;
                apiCommonParams.userCreated = user.userId;
                apiCommonParams.userModified = user.userId;
            }
        }
        getUserList(storedToken);
    }, [props]);

    async function getUserList() {
        setUserListState(await apis.getUsers(applicationId, siteId,storedToken))
    }

    const showHideAddTask = async function (show, taskDetail, headerComData, forGetTaskList) {
        if (show) {
            setUserStoryListState(false);
            _showHideAddTask(false);
            _showHideAddUserStory(false)
             _showHideAddFeature(false);
             setShowFeatureList(false);
        }

        if (headerComData) {
            setStateFromHeader(headerComData);
        }

        setTimeout(() => {

            let isDeleted = false;

        // If URL contains taskId but taskDetail is null → deleted
        if (headerComData?.taskId && !taskDetail) {
            isDeleted = true;
        }

        // If taskDetail exists but marked invalid
        if (taskDetail) {
            isDeleted =
                taskDetail.taskId === 0 ||
                taskDetail.taskdetail === null;
        }



            if (isDeleted) {
                setIsTaskDeleted(true);
                setTask(null);
            } else {
                setIsTaskDeleted(false);
                setTask(taskDetail);
            }

            _showHideAddTask(show);
        }, 100);


        if (forGetTaskList) {
            let data = {
                masterProjectId: headerComData['masterProjectId'],
                masterReleaseId: headerComData['masterReleaseId'],
                masterFeatureId: headerComData['masterFeatureId'],
                masterUserId: headerComData['masterUserId'],
                userStoryId: 0,
                filterStartDate: headerComData['filterStartDate'],
                filterEndDate: headerComData['filterEndDate']
            }

            callGetTaskList(data,storedToken);
        }
        document.body.scrollTop = 0;
  		document.documentElement.scrollTop = 0;
    }

    const callGetTaskList = (requestParam) => {
        trackPromise(
            getTaskList(dispatch,applicationId, siteId, requestParam,storedToken).then((response) => {
                if (response && response.taskDetails && response.taskDetails.length > 0) {
                }
            }).catch((error) => {
                console.log(error);
            })
        );
    }

    const showHideUserStory = function (show, userStoryDetail, headerComData, forGetTaskList) {
        if (show) {
            _showHideAddTask(false);
            _showHideAddUserStory(false)
             _showHideAddFeature(false)
            setUserStoryListState(false)
            setShowFeatureList(false);
        }

        if (headerComData) {
            setStateFromHeader(headerComData);
        }

        setTimeout(() => {
            setUserStoryDetailState(userStoryDetail);
            _showHideAddUserStory(show);
            //setUserListState(null);
        }, 100);

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        // if (forGetTaskList) {
        //     let data = {
        //         masterProjectId: headerComData['masterProjectId'],
        //         masterReleaseId: headerComData['masterReleaseId'],
        //         masterUserId: headerComData['masterUserId'],
        //         userStoryId: headerComData['userStoryId'],
        //         filterStartDate: headerComData['filterStartDate'],
        //         filterEndDate: headerComData['filterEndDate']
        //     }

        //     callGetTaskList(data);
        // }
    }

const showHideFeature = (show, featureDetail = null, headerComData = null) => {
  _showHideAddTask(false);
  _showHideAddUserStory(false);
  setUserStoryListState(false);
  setShowFeatureList(false);

  if (headerComData) {
    setStateFromHeader(headerComData);
  }

  if (show && featureDetail) {
    setFeatureDetailState(featureDetail); 
  } else {
    setFeatureDetailState(null); 
  }

  _showHideAddFeature(show);

  if (show) {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
};


    const [userStoryListState, setUserStoryListState] = useState(false);

    const showHideUserStoryList = async function (show, userStoryDetail, headerComData, story_type) {
        if (show) {
            setUserStoryListState(false);
            _showHideAddUserStory(false)
             _showHideAddFeature(false);
            _showHideAddTask(false);
            setShowFeatureList(false);
        }

        // let userList = [];
        if (userStoryDetail) {
            userStoryDetail = await apis.getUserStoryById(applicationId, siteId,userStoryDetail,storedToken);
            // userList = await apis.getUsers()
        }

        if (headerComData) {
            setStateFromHeader(headerComData);
        }

        setTimeout(() => {
            setUserStoryListState(show);
            setUserStoryDetailState(userStoryDetail);
            // setUserListState(userList);
            if (story_type === 'edit')
                _showHideAddUserStory(contextDetails.isAdminUser)
        }, 100);

    }

    const showHideFeatureList = async (show, headerComData = null) => {
    
    _showHideAddTask(false);
    _showHideAddUserStory(false);
    _showHideAddFeature(false);
    setUserStoryListState(false);

    
    setShowFeatureList(show);

    if (headerComData) {
        setStateFromHeader(headerComData);
    }

    if (show && headerComData) {
        const { masterProjectId, masterReleaseId } = headerComData;

        
        if (masterProjectId) {
            const storedToken = localStorage.getItem('keycloakToken');
            
            await apis.getFeatureList(applicationId, siteId,masterProjectId, storedToken);
            setFeatureDetailState(null);
        }
    }

    if (show) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}


    const taskListProps = (headerComData, updateUserStoryDetail) => {
        setStateFromHeader(headerComData);
        setUserStoryDetailState(updateUserStoryDetail);
    }

    const hideAllAddForms = () => {
        setUserStoryListState(false);
        _showHideAddTask(false);
        _showHideAddUserStory(false)
         _showHideAddFeature(false);
         setShowFeatureList(false);
    }
     

    return (
        <div>
            <Header hideAllAddForms={hideAllAddForms} showComments={showComments} addTask={showHideAddTask} showAddFeature={showHideFeature} addUserStory={showHideUserStory} userStoryList={showHideUserStoryList} showFeatureList={showHideFeatureList} editUserStory={showHideUserStory} editFeature={showHideFeature} getTaskList={taskListProps} isAdmin={contextDetails.isAdminUser} userId={contextDetails.userId}></Header>
            <TaskBoard setHeightOfAllColumn={setHeightOfAllColumn} commentsVisible={commentsVisible} editTask={showHideAddTask} header_data={stateFromHeader} editUserStory={showHideUserStory} hideUserStoryList={showHideUserStoryList} userStoryDetail={userStoryDetailState} isAdmin={contextDetails.isAdminUser}></TaskBoard>

            {showAddTask ? <AddTask isAdmin={contextDetails.isAdminUser} userId={contextDetails.userId} projectPermissions={contextDetails.projectPermissions} hideAddTask={showHideAddTask} task={task} isTaskDeleted={isTaskDeleted} userList={userListState} header_data={stateFromHeader}></AddTask> : ""}

            {showAddUserStory ? <AddUserStory hideUserStory={showHideUserStory} isAdmin={contextDetails.isAdminUser} userId={contextDetails.userId} userStoryDetail={userStoryDetailState} userList={userListState} header_data={stateFromHeader}></AddUserStory> : ""}
            {showAddFeature ? (
                <AddFeature
                    hideFeature={showHideFeature}  
                    isAdmin={contextDetails.isAdminUser} 
                    userId={contextDetails.userId} 
                    featureDetail={featureDetailState} 
                    header_data={stateFromHeader}    
                />
            ) : ""}

            {userStoryListState ? <UserStory  hideUserStoryList={showHideUserStoryList} editUserStory={showHideUserStory} header_data={stateFromHeader}></UserStory> : ""}
            {showFeatureList ? (
    <FeatureList
        hideFeatureList={showHideFeatureList}
        header_data={stateFromHeader}
        editFeature={showHideFeature}
    />
) : ""}
        </div>
    )
}

export default Dashboard;
